export default __webpack_public_path__ + "static/SRC 3340 - Product Specifications & Technical Data-83028a8e1983d3f6e0753700e5f50572.pdf";